import type {
  CancelarParcelaUseCase,
  CreateParcelaUseCase,
  ListParcelasUseCase,
  PagarParcelaUseCase,
} from '@/application/port/in/ParcelaUseCase';
import type {
  CancelarParcelaCommand,
  CreateParcelaCommand,
  PagarParcelaCommand,
} from '@/application/port/in/dto/ParcelaCommand';
import type { ParcelaGateway } from '@/application/port/out/ParcelaGateway';
import type { Parcela } from '@/domain/model/Parcela';

export class ListParcelasUseCaseImpl implements ListParcelasUseCase {
  constructor(private readonly gateway: ParcelaGateway) {}
  execute(matriculaId: string): Promise<Parcela[]> {
    if (!matriculaId)
      return Promise.reject(new Error('ID da matrícula é obrigatório'));
    return this.gateway.list(matriculaId);
  }
}

export class CreateParcelaUseCaseImpl implements CreateParcelaUseCase {
  constructor(private readonly gateway: ParcelaGateway) {}
  execute(command: CreateParcelaCommand): Promise<Parcela> {
    if (command.numeroParcela < 1)
      return Promise.reject(new Error('Número da parcela deve ser >= 1'));
    if (command.valor <= 0)
      return Promise.reject(new Error('Valor deve ser maior que zero'));
    return this.gateway.create(command);
  }
}

export class PagarParcelaUseCaseImpl implements PagarParcelaUseCase {
  constructor(private readonly gateway: ParcelaGateway) {}
  execute(command: PagarParcelaCommand): Promise<Parcela> {
    return this.gateway.pagar(command);
  }
}

export class CancelarParcelaUseCaseImpl implements CancelarParcelaUseCase {
  constructor(private readonly gateway: ParcelaGateway) {}
  execute(command: CancelarParcelaCommand): Promise<void> {
    return this.gateway.cancelar(command);
  }
}
